<template>
  <div>
    <typeahead :data="searchResults"
               :serializer="(r) => r.display"
               :show-all-results="true"
               :max-matches="30"
               v-model="searchTerm"
               :minMatchingChars="2"
               @hit="$emit('select', $event)"
               placeholder="Suche Kunden, Bestellungen, Rechnungen, ...">
      <template slot="suggestion" slot-scope="{ data, htmlText }">
        <div>
          <font-awesome-icon :icon="data.icon" class="text-muted mr-2" fixed-width/>
          <span v-html="htmlText"></span>
          <i class="ml-auto fab fa-github-square fa-2x"></i>
        </div>
      </template>
    </typeahead>
  </div>
</template>

<script>
import {getIcon} from "@/utils/business-objects";

export default {
  props: {
    type: String
  },
  data() {
    return {
      searchTerm: '',
      searchResults: []
    }
  },
  watch: {
    searchTerm(newVal, oldVal) {
      if ((!newVal || newVal === '') && oldVal) {
        console.log('null selected')
        this.$emit('select', null)
      } else
        this.$api.post('/search', {
          term: this.searchTerm,
          type: this.type
        }).then(response => {
          response.data.forEach(sr => sr.icon = this.icon(sr.type))
          this.searchResults = response.data
        }).catch(error => this.handleError(error))
    }
  },
  methods: {
    icon(type) {
      return getIcon(type)
    }
  }
}
</script>
